/**
 * intl-latam-ec-form-secure
 * Api to secure Application
 *
 * OpenAPI spec version: 1.2.1
 * Contact: cgudino@kruger.com.ec
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import {
    HttpClient, HttpHeaders, HttpParams,
    HttpResponse, HttpEvent
} from '@angular/common/http';
import { CustomHttpUrlEncodingCodec } from '../encoder';

import { Observable } from 'rxjs/Observable';

import { ModelApiResponse } from '../model-seguridad/modelApiResponse';
import { Rol } from '../model-seguridad/rol';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';


@Injectable()
export class RolesService {
    @BlockUI() blockUI: NgBlockUI;
    protected basePath = environment.URL_API_SECURE;
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Post rol
     * Create new rol structure
     * @param body Request object for creation rol
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public intlLatamEcFormSecureCreateRol(body: Rol, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public intlLatamEcFormSecureCreateRol(body: Rol, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public intlLatamEcFormSecureCreateRol(body: Rol, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public intlLatamEcFormSecureCreateRol(body: Rol, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
        this.blockUI.start();
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling intlLatamEcFormSecureCreateRol.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<any>(`${this.basePath}/rol`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).pipe(
            map(response => {
                this.blockUI.stop();
                return response
            })
        );
    }

    /**
     * delete rol
     * delete existing rol structure
     * @param name delete rol by name
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public intlLatamEcFormSecureDeleteRol(name: string, observe?: 'body', reportProgress?: boolean): Observable<ModelApiResponse>;
    public intlLatamEcFormSecureDeleteRol(name: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ModelApiResponse>>;
    public intlLatamEcFormSecureDeleteRol(name: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ModelApiResponse>>;
    public intlLatamEcFormSecureDeleteRol(name: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
        this.blockUI.start();
        if (name === null || name === undefined) {
            throw new Error('Required parameter name was null or undefined when calling intlLatamEcFormSecureDeleteRol.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (name !== undefined && name !== null) {
            queryParameters = queryParameters.set('name', <any>name);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.delete<ModelApiResponse>(`${this.basePath}/rol`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).pipe(
            map(response => {
                this.blockUI.stop();
                return response
            })
        );
    }

    /**
     * get all ids menus in array for role name
     * get all menus ids for role name
     * @param name 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public intlLatamEcFormSecureGetMenusInRol(name: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public intlLatamEcFormSecureGetMenusInRol(name: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public intlLatamEcFormSecureGetMenusInRol(name: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public intlLatamEcFormSecureGetMenusInRol(name: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
        this.blockUI.start();
        if (name === null || name === undefined) {
            throw new Error('Required parameter name was null or undefined when calling intlLatamEcFormSecureGetMenusInRol.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (name !== undefined && name !== null) {
            queryParameters = queryParameters.set('name', <any>name);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<any>(`${this.basePath}/roles/menus`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).pipe(
            map(response => {
                this.blockUI.stop();
                return response
            })
        );
    }

    /**
     * get public roles
     * get all roles when restricted is enabled response only roles
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public intlLatamEcFormSecureGetPublicRoles(observe?: 'body', reportProgress?: boolean): Observable<any>;
    public intlLatamEcFormSecureGetPublicRoles(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public intlLatamEcFormSecureGetPublicRoles(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public intlLatamEcFormSecureGetPublicRoles(observe: any = 'body', reportProgress: boolean = false): Observable<any> {
        this.blockUI.start();
        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<any>(`${this.basePath}/roles/public`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).pipe(
            map(response => {
                this.blockUI.stop();
                return response
            })
        );
    }

    /**
     * get rol
     * get existing rol structure
     * @param name get rol by name
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public intlLatamEcFormSecureGetRol(name: string, observe?: 'body', reportProgress?: boolean): Observable<ModelApiResponse>;
    public intlLatamEcFormSecureGetRol(name: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ModelApiResponse>>;
    public intlLatamEcFormSecureGetRol(name: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ModelApiResponse>>;
    public intlLatamEcFormSecureGetRol(name: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
        this.blockUI.start();
        if (name === null || name === undefined) {
            throw new Error('Required parameter name was null or undefined when calling intlLatamEcFormSecureGetRol.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (name !== undefined && name !== null) {
            queryParameters = queryParameters.set('name', <any>name);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<ModelApiResponse>(`${this.basePath}/rol`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).pipe(
            map(response => {
                this.blockUI.stop();
                return response
            })
        );
    }

    public intlLatamEcFormSecureLoginPortal(userId: string): Observable<any> {
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling intlLatamEcFormSecureGetRolesByUserId.');
        }
        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        return this.httpClient.get<any>(`${this.basePath}/login/${encodeURIComponent(String(userId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers
            }
        ).pipe(
            map(response => {
                this.blockUI.stop();
                if (!response.brokerId) {
                    throw Error(JSON.stringify(response));
                }
                return response
            })
        );
    }

    /**
     * get all roles
     * get all roles
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public intlLatamEcFormSecureGetRoles(observe?: 'body', reportProgress?: boolean): Observable<any>;
    public intlLatamEcFormSecureGetRoles(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public intlLatamEcFormSecureGetRoles(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public intlLatamEcFormSecureGetRoles(observe: any = 'body', reportProgress: boolean = false): Observable<any> {
        this.blockUI.start();
        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<any>(`${this.basePath}/roles`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).pipe(
            map(response => {
                this.blockUI.stop();
                return response
            })
        );
    }

    /**
     * get all object roles of user
     * get all object roles of user
     * @param userId Request array roles by id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public intlLatamEcFormSecureGetRolesByUserId(userId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public intlLatamEcFormSecureGetRolesByUserId(userId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public intlLatamEcFormSecureGetRolesByUserId(userId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public intlLatamEcFormSecureGetRolesByUserId(userId: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
        this.blockUI.start();
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling intlLatamEcFormSecureGetRolesByUserId.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<any>(`${this.basePath}/roles/byUserId/${encodeURIComponent(String(userId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).pipe(
            map(response => {
                this.blockUI.stop();
                return response
            })
        );
    }

    /**
     * get all names rules in array for role
     * get all rules
     * @param name 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public intlLatamEcFormSecureGetRulesInRol(name: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public intlLatamEcFormSecureGetRulesInRol(name: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public intlLatamEcFormSecureGetRulesInRol(name: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public intlLatamEcFormSecureGetRulesInRol(name: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
        this.blockUI.start();
        if (name === null || name === undefined) {
            throw new Error('Required parameter name was null or undefined when calling intlLatamEcFormSecureGetRulesInRol.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (name !== undefined && name !== null) {
            queryParameters = queryParameters.set('name', <any>name);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<any>(`${this.basePath}/roles/rules`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).pipe(
            map(response => {
                this.blockUI.stop();
                return response
            })
        );
    }

    /**
     * get all object userRol in this rol by rol name
     * get all object userRol in this rol by rol name
     * @param name Request array users by id rol
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public intlLatamEcFormSecureGetUsersByRolId(name: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public intlLatamEcFormSecureGetUsersByRolId(name: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public intlLatamEcFormSecureGetUsersByRolId(name: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public intlLatamEcFormSecureGetUsersByRolId(name: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
        this.blockUI.start();
        if (name === null || name === undefined) {
            throw new Error('Required parameter name was null or undefined when calling intlLatamEcFormSecureGetUsersByRolId.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (name !== undefined && name !== null) {
            queryParameters = queryParameters.set('name', <any>name);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<any>(`${this.basePath}/roles/users/`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).pipe(
            map(response => {
                this.blockUI.stop();
                return response
            })
        );
    }

    /**
     * Put rol
     * Update existing rol structure
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public intlLatamEcFormSecureUpdateRol(body: Rol, observe?: 'body', reportProgress?: boolean): Observable<ModelApiResponse>;
    public intlLatamEcFormSecureUpdateRol(body: Rol, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ModelApiResponse>>;
    public intlLatamEcFormSecureUpdateRol(body: Rol, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ModelApiResponse>>;
    public intlLatamEcFormSecureUpdateRol(body: Rol, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
        this.blockUI.start();
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling intlLatamEcFormSecureUpdateRol.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<ModelApiResponse>(`${this.basePath}/rol`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        ).pipe(
            map(response => {
                this.blockUI.stop();
                return response
            })
        );
    }

}
